module.exports = __webpack_public_path__ + "static/media/harminder.cc7691de.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/members/harminder.jpg
 ** module id = 779
 ** module chunks = 0
 **/